<template>
    <div class="the-detail-footer">
        <footer class="footer">
            <ul class="footer__links d-flex align-center">
                <li v-for="link in links" :key="link.title">
                    <isc-link :href="link.href">{{ link.title }}</isc-link>
                </li>
            </ul>

            <p class="footer__copyright">
                &copy; 2019-2021 杭州指令集智能科技有限公司 版权所有
                <isc-link href="https://beian.miit.gov.cn/" target="_blank">浙ICP备18052408号-1</isc-link>
            </p>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'TheDetailFooter',

    data() {
        return {
            links: [
                { href: 'https://www.isyscore.com/', title: '指令集官网' },
                { href: 'https://www.isyscore.com/about/', title: '公司简介' },
                { href: 'https://www.isyscore.com/contact/', title: '联系我们' },
                { href: 'https://www.isyscore.com/about/join', title: '加入我们' }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.the-detail-footer {
    padding-top: 20px;
    padding-bottom: 20px;
    border-top: 1px solid #f2f2f2;
}

.footer {
    font-size: 12px;
    color: #999;
    line-height: 24px;

    a {
        position: relative;
        color: #999;
    }

    &__links {
        a {
            margin-right: 12px;

            &::after {
                content: '';
                width: 1px;
                height: 12px;
                background: #ddd;
                margin-left: 12px;
            }
        }

        li:last-child a::after {
            display: none;
        }
    }
}
</style>
